
<template>
    <loadingSpinner v-if="loading"  :loadingname=loadingname />
    <div v-if="!loading" class="bg-black space-y-4 px-8" style="padding-bottom: 14%; padding-top: 2%;">
    <h2 class="text-xl text-white font-semibold" style="display: flex; justify-content: center;">Request Referral</h2>
    <fieldset class="fieldset">        
            <input v-model="data.job_id" maxlength="100" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Job ID (Optional)" style="width: 100%; height: 3rem;" />
            <span></span>
            <input v-model="data.job_url" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Job Url (Mandatory)" style="width: 100%; height: 3rem;" />
                        <span></span>

            <input v-model="data.amount" min="100" type="number" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Amount (Mandatory)" style="width: 100%; height: 3rem;" />
            <span></span>
            <Multiselect
            v-model="data.company"
            :options="companies"
            placeholder="Select a company"
            track-by="name"
            label="name"
            :searchable="true"
            class="text-xl font-semibold"
          />
            <span></span>          
            <textarea maxlength="500" v-model="data.about" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="About (Optional)" style="width: 100%; height: 12rem;" ></textarea>
            <span></span>
            <button ref="placeBtn" name = "place" @click="place" class="rounded-md text-xl text-black font-semibold bg-white"  style="height: 2.75rem; width: 100%;" :disabled="!canEnable">
            <span v-if="placing" class="loading loading-dots loading-xl"></span>
            <span v-if="!placing">Place</span>  
            </button>          
          <span></span>
          <span></span>
        </fieldset>
    </div>
</template>

<script>
import { apiCall } from '@/js/main';
import loadingSpinner from './loading.vue';
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css'

const initial = {
        company: "",
        job_url: "",
        job_id: "",
        about: "",
        amount: 100,
      }
export default {
  name: "placeRequest",
  data(){
    return {
      data: { ...initial },
      loadingname: 'Placing Request',
      loading: false,
      companies: [],
      placing: false
    }
  },
  components:{
    loadingSpinner: loadingSpinner,
    Multiselect
    },
  methods:{
    async place(){
      const input =  this.$refs.placeBtn
      input.disabled = true
      this.placing = true
      var data = await apiCall("/referral", "POST", this.data)
      if (data.success){
        this.$emit('update-credits', this.data.amount * -1)
        this.$emit('push-alert', true, "Your request is placed")
        this.data = { ...initial }
      }
      else{
        this.$emit('push-alert', false, data.error_message)
      }
      input.disabled = false
      this.placing = false
    }
  },
  computed: {
        canEnable() {
            return this.data.company !== "" && this.data.amount >= 100 && this.data.job_url !== "";
        }
        },
  async mounted(){
    window.scrollTo({ top: 0, behavior: 'auto' })
    var data = await apiCall("/user/company", "GET", null)

    if (data.success){
        this.companies = data.data
      }

  }
}
</script>
